import React, { createContext, useReducer, useCallback, useMemo } from "react";
import { LocalityReducer } from "./localityReducer";
import { TYPES } from "./localityTypes";
import { Locality } from "../views/Modals/Locality/Locality";
import { initialState } from "./localityInitialState";

export const LocalityContext = createContext();

export function LocalityProvider({ children }) {
  const [state, dispatch] = useReducer(LocalityReducer, initialState);

  const setToggleModalOpen = useCallback(
    (payload) => dispatch({ type: TYPES.SET_TOGGLE_MODAL_OPEN, payload }),
    []
  );

  const setFieldIsFictious = useCallback(
    (payload) => dispatch({ type: TYPES.SET_FIELD_IS_FICTIOUS, payload }),
    []
  );

  const setField = useCallback(
    (payload) => dispatch({ type: TYPES.SET_FIELD, payload }),
    []
  );

  const setClearFieldAndItsChildren = useCallback(
    (payload) =>
      dispatch({ type: TYPES.SET_CLEAR_FIELD_AND_CLEAR_CHILDREN, payload }),
    []
  );

  const setClearFormData = useCallback(() => {
    dispatch({ type: TYPES.SET_CLEAR_FORM_DATA });
  }, []);

  const setRequestedLocalitiesData = useCallback((payload) => {
    dispatch({ type: TYPES.SET_REQUESTED_LOCALITIES_DATA, payload });
  }, []);

  const setLastForm = useCallback((payload) => {
    dispatch({ type: TYPES.SET_LAST_FORM, payload });
  }, []);

  const setLastCreation = useCallback((payload) => {
    dispatch({ type: TYPES.SET_LAST_CREATION, payload });
  }, []);

  const providerMemo = useMemo(
    () => ({
      ...state,
      setToggleModalOpen,
      setFieldIsFictious,
      setField,
      setClearFieldAndItsChildren,
      setClearFormData,
      setRequestedLocalitiesData,
      setLastForm,
      setLastCreation,
    }),
    [
      state,
      setToggleModalOpen,
      setFieldIsFictious,
      setField,
      setClearFieldAndItsChildren,
      setClearFormData,
      setRequestedLocalitiesData,
      setLastForm,
      setLastCreation,
    ]
  );

  return (
    <LocalityContext.Provider value={providerMemo}>
      {children}
      <Locality />
    </LocalityContext.Provider>
  );
}
